import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface AuthLoadingComponentStyles {
  root: AppSx;
  logo: AppSx;
}

export function buildAuthLoadingComponentStyles(_theme: Theme): AuthLoadingComponentStyles {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      gap: 2,
    },
    logo: {
      height: 76,
      maxWidth: 280,
      width: "auto",
      objectFit: "contain",
      mb: 1.5,
    },
  };
}
